module.exports = __webpack_public_path__ + "img/dark-mode-icon-dark.d9f646e9.svg";